<template>
  <div class="tab-container">
    <div class="tab">
      <ul class="clearfix">
        <li
          :class="{ actived: item.selected }"
          @click="clickTab(item)"
          v-for="item in tabs"
          :key="item.path"
        >
          <div class="title">
            {{ item.title }}

            <!-- <img v-if="item.isNew" class="hot" src="@/assets/ksxg/NEW.png" />
            <img v-if="item.isHot" class="hot" src="@/assets/ksxg/hot.png" /> -->
          </div>
          <!-- <div class="des">{{ item.des }}</div> -->
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  created() {
    this.tabs.forEach((tab) => {
      tab.selected = this.$route.path.includes(tab.path);
    });
  },
  data() {
    return {
      tabs: [
        {
          path: "orgnazition",
          selected: false,
          title: "各省/市信息",
          // des: "题型丰富，轻松应对测评",
        },
        //{
        //  path: "point",
        //   selected: false,
        //  title: "考点信息",
        //  // des: "等级划分，清晰反馈学情",
        // },
        //{
        // path: "mechanism",
        //   selected: false,
        //   title: "报名培训中心信息",
        //   // des: "各级省委组委会，地级市组委会，考点和报名培训中心信息",
        //   // isNew: true,
        //},
      ],
    };
  },
  computed: {
    // actived() {
    //   return item => {
    //     // return this.$route.path.indexOf(item.name) != -1;
    //     return item.selected;
    //   };
    // }
  },
  methods: {
    clickTab(item) {
      this.tabs.forEach((tab) => {
        tab.selected = false;
      });
      item.selected = true;
      this.$router.push({ path: item.path });
    },
  },
};
</script>
<style lang="less" scoped>
.tab-container {
  background-color: white;
  margin: 0 auto;
  border-bottom: solid 1px #dedfe1;
  text-align: center;
  .tab {
    margin: 0 auto;
    width: 1200px;
    ul {
      li:nth-child(2) {
        border-left: solid 1px #dedfe1;
        border-right: solid 1px #dedfe1;
      }
      li {
        //width: 400px;
        width: 100%;
        height: 113px;
        background-color: white;
        cursor: pointer;
        float: left;
        font-size: 16px;
        color: #333333;
        position: relative;
        text-align: center;
        display: flex;
        vertical-align: middle;
        justify-content: center;
        .hot {
          // position: absolute;
          // top: 22px;
          // left: 250px;
        }
        .title {
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 18px;
          padding: 20px 0 0 0;
          img {
            margin-left: 10px;
          }
        }
        .des {
          color: #999999;
          font-size: 14px;
          padding: 20px 0 0 0;
        }

        &.actived,
        &:hover {
          background-color: #eeeeee;
          border-bottom: solid #f78b24 2px;
        }
      }
    }
  }
}
</style>
